__turbopack_context__.v({
  "blockGrid": "BlockGrid-module-scss-module__eiMmmq__blockGrid",
  "blockGridInner": "BlockGrid-module-scss-module__eiMmmq__blockGridInner",
  "ctaCardWrapper": "BlockGrid-module-scss-module__eiMmmq__ctaCardWrapper",
  "flushBottom": "BlockGrid-module-scss-module__eiMmmq__flushBottom",
  "flushBottomMobile": "BlockGrid-module-scss-module__eiMmmq__flushBottomMobile",
  "flushTop": "BlockGrid-module-scss-module__eiMmmq__flushTop",
  "fullWidth": "BlockGrid-module-scss-module__eiMmmq__fullWidth",
  "gridRow": "BlockGrid-module-scss-module__eiMmmq__gridRow",
  "roundedBottom": "BlockGrid-module-scss-module__eiMmmq__roundedBottom",
  "roundedTop": "BlockGrid-module-scss-module__eiMmmq__roundedTop",
});
